import {
  getContextOfferingsUrl,
  getSectionsContextsUrl,
  getSectionsUrl,
} from "../config/Config";
import { getRequest } from "./ServiceHelper";

export class SectionService {
  static getSectionsByFacultyID = (facultyId) => {
    const params = {};
    if (facultyId) {
      params.facultyId = facultyId;
    }
    return getRequest(getSectionsUrl(), params);
  };

  static getFullSectionByContextIDs = (contextId, termId = null) => {
    return getRequest(getSectionsContextsUrl(), {
      contextId: contextId,
      termId: termId,
    });
  };

  static getOfferingsByContext = ({
    contextId,
    ownerCourseCode,
    courseLevels,
    taxonomyLevels,
    page,
    qc,
    futureMappings,
  }) => {
    let params = {};
    if (ownerCourseCode) {
      params.ownerCourseCode = ownerCourseCode;
    } else {
      params.ownerCourseCode = [];
    }
    if (!!courseLevels && courseLevels.length > 0) {
      params.courseLevels = courseLevels;
    }
    if (!!taxonomyLevels && taxonomyLevels.length > 0) {
      params.taxonomyLevels = taxonomyLevels;
    }
    if (typeof page !== "undefined") {
      params.page = page;
    }
    if (qc) {
      params.qc = qc;
    }
    if (futureMappings) {
      params.futureMappings = futureMappings;
    }
    return getRequest(getContextOfferingsUrl(contextId), params);
  };
}
